/*
  Two guards around the Loox review widget on the PDP. Loox owns the review
  UI; the stars under the title link to it. No theme-side caret.

  1. Products with no reviews: Loox paints "Be the first to write a review",
     which reads worse than no section at all. Hide the block.
  2. Loox ships a server-rendered review list for crawlers, hidden behind its
     own inline style and swapped for the live widget once its script runs. If
     that never completes (blocked assets, an ad blocker, the http dev server)
     the style is never removed and a product with hundreds of reviews shows
     none. Reveal the server-rendered copy as a fallback.
*/
(function () {
  function feedBlock() {
    var anchor = document.getElementById('looxReviews');
    return anchor && (anchor.closest('[id^="shopify-block-"]') || anchor.parentElement);
  }

  function init() {
    var feed = feedBlock();
    if (!feed) return;
    if (!feed.id) feed.id = 'fm-review-feed';

    var meta = document.querySelector('.fm-review-meta');
    var count = meta ? parseInt(meta.dataset.reviewCount, 10) || 0 : 0;
    if (!count) { feed.hidden = true; return; }

    setTimeout(function () {
      var tempStyle = document.querySelector('style.loox-temp-hiding-style');
      if (!tempStyle) return;
      var ssr = document.getElementById('loox-reviews-feed');
      var widgetLoaded = feed.querySelector('iframe, .loox-reviews-widget');
      if (widgetLoaded || !ssr) return;
      tempStyle.remove();
    }, 5000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
